import {
  Component,
  OnInit,
  Inject,
  ViewChild,
  ElementRef
} from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { CommonService } from "src/app/_services/common.service";
import { imgUrl } from 'src/app/_services/url';

@Component({
  selector: "app-videoplayer",
  templateUrl: "./videoplayer.component.html",
  styleUrls: ["./videoplayer.component.scss"]
})
export class VideoplayerComponent implements OnInit {
  dataplay: string;
  slideIndex = 0;
  imgUrl = imgUrl;

  @ViewChild("videoPlayer") videoplayer: ElementRef;
  loop = false;
  dataplayer: any;
  constructor(
    public dialogRef: MatDialogRef<VideoplayerComponent>,
    @Inject(MAT_DIALOG_DATA) public data
  ) {
    this.dataplay = data.href;
    this.slideIndex = data.index;
    console.log(this.dataplay.length);

    if (typeof this.dataplay !== "string") {
      this.loop = !this.loop;
    }
    this.dataplayer = this.dataplay[this.slideIndex];
    console.log(this.dataplayer);
  }

  ngOnInit() {}
  onNoClick(): void {
    this.dialogRef.close();
  }

  plusSlides(n) {
    console.log(this.slideIndex, this.dataplay.length - 1);

      if (this.dataplayer !== undefined) {
        if (this.slideIndex <= this.dataplay.length - 1) {
          if (n === 1) {
            this.slideIndex = this.slideIndex + 1;
          } else {
            this.slideIndex = this.slideIndex - 1;
          }
        }

        console.log(this.slideIndex);

        this.dataplayer = this.dataplay[this.slideIndex];
        console.log(this.dataplayer);

        this.videoplayer.nativeElement.play();
        console.log(this.videoplayer.nativeElement.load());
      }
  }

  currentSlide(n) {
    if (this.slideIndex < this.dataplay.length) {
      console.log(n);
      this.slideIndex = this.slideIndex + n;
      this.dataplayer = this.dataplay[this.slideIndex];
      console.log(this.dataplayer);
      this.videoplayer.nativeElement.load();
    }
  }
}
